import { render, staticRenderFns } from "./HighlightDialog.vue?vue&type=template&id=c169be52&"
import script from "./HighlightDialog.vue?vue&type=script&lang=js&"
export * from "./HighlightDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports